import type { SVGProps } from 'react';
import * as React from 'react';

const SvgChevronRightSm = (props: SVGProps<SVGSVGElement>) => (
  <svg
    aria-hidden="true"
    fill="none"
    height="100%"
    stroke="currentColor"
    strokeWidth={1.5}
    viewBox="0 0 16 16"
    width="100%"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    className={props.className ? `rtl:-scale-x-100 ${props.className}` : 'rtl:-scale-x-100'}
  >
    <path d="M6.667 10.667 9.333 8 6.667 5.333" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
export default SvgChevronRightSm;
